import { Reveal } from "./motion";

const lines = [
  "New music.",
  "New technologies.",
  "New experiences.",
  "New collaborations.",
  "New ways of working with individuals and organizations.",
];

const Evolving = () => (
  <section
    id="evolving"
    data-testid="evolving-section"
    className="relative mx-auto max-w-7xl px-6 py-32 lg:px-12 lg:py-40"
  >
    <div className="grid grid-cols-1 gap-16 lg:grid-cols-2 lg:gap-24">
      <Reveal>
        <h2
          data-testid="evolving-headline"
          className="font-serif-display text-4xl font-light leading-[1.12] tracking-tight text-[#16130e] sm:text-5xl"
        >
          THE COLLECTIVE IS <span className="text-gold-gradient">STILL EVOLVING.</span>
        </h2>
      </Reveal>

      <div>
        <Reveal delay={0.1}>
          <p className="text-sm font-extralight leading-relaxed text-black/60 md:text-base">
            SEAL is intentionally built as a living collective.
          </p>
        </Reveal>
        <div className="mt-8 space-y-4">
          {lines.map((line, i) => (
            <Reveal key={line} delay={0.12 + i * 0.06}>
              <p className="font-serif-display flex items-baseline gap-4 text-xl font-light italic text-black/75 md:text-2xl">
                <span className="h-1 w-1 shrink-0 translate-y-[-4px] rounded-full bg-[#b8912e]" />
                {line}
              </p>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.45}>
          <p className="mt-10 text-sm font-extralight leading-relaxed text-black/60 md:text-base">
            Not everything has to fit into one box. It only has to come from the same center.
          </p>
          <p
            data-testid="evolving-keyline"
            className="font-serif-display mt-6 text-3xl font-light text-gold-gradient sm:text-4xl"
          >
            THE HEART.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Evolving;
